import script from "./UsersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersPage.vue?vue&type=script&setup=true&lang=ts"

import "./UsersPage.vue?vue&type=style&index=0&id=32b27626&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b27626"]])

export default __exports__